import { render, staticRenderFns } from "./ConfirmationDeleteSpace.vue?vue&type=template&id=4eaf80d0"
import script from "./ConfirmationDeleteSpace.vue?vue&type=script&lang=js"
export * from "./ConfirmationDeleteSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports